module.exports = __webpack_public_path__ + "static/media/facerecog.808bd297.jpg";